import * as React from 'react';
import { classes } from '../../helpers';
import { elevationCss } from '../../helpers/elevations';
import { Portal } from '../Popover/Portal';
import { useTheme } from '../Theme/Theme';
import { style as modalStyle } from './style';
export const Modal = (props) => {
    const { children, isVisible, style = {}, width, elevation = 24 } = props;
    const [className, updateClassName] = React.useState('');
    const [open, updateOpen] = React.useState(isVisible);
    const [lastVisible, updateLastVisible] = React.useState(open);
    const theme = useTheme();
    const css = modalStyle(theme);
    const onHide = () => {
        setTimeout(() => updateOpen(false), 200);
        updateClassName(css.slideOutRight);
        setTimeout(() => updateClassName(''), 200);
    };
    React.useEffect(() => {
        if (!isVisible && lastVisible) {
            onHide();
        }
        updateLastVisible(isVisible);
        if (isVisible) {
            updateOpen(true);
        }
    }, [isVisible]);
    if (!open) {
        return null;
    }
    return (React.createElement(Portal, { key: "modal" },
        React.createElement("div", { key: "mask", className: css.maskStyle, onClick: () => { var _a; return (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props); } },
            React.createElement("div", { key: "container", className: classes(css.mediaQueries, css.modalContainer, elevationCss(elevation), className), style: Object.assign({ width }, style), onClick: (e) => e.stopPropagation() },
                React.createElement("div", null, children)))));
};
//# sourceMappingURL=Modal.js.map